import React from "react";
import { useTranslation } from "react-i18next";
import { ApiInternal } from "src/api/api_internal";
import { FullDevice } from "src/api/generated/frontend_internal_v1";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link ExpireDeviceKeyDialog}
 */
export type ExpireDeviceKeyDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful expire */
    onExpire: () => void;
    /** The device to expire */
    device: FullDevice | undefined;
};

/**
 * Dialog to expire the device key
 */
export default function ExpireDeviceKeyDialog(props: ExpireDeviceKeyDialogProps) {
    const [t] = useTranslation("dialog-expire-device-key");

    if (!props.device) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.device) return;
                await ApiInternal.devices.expireDevice(props.device.uuid);
                notify.success(t("toast.key-expired-successfully"));
                props.onExpire();
            }}
            title={t("heading.expire-key", { device: props.device.dnsname })}
            description={t("description.expire-key")}
            confirmLabel={t("button.expire-key")}
        />
    );
}
